import mockAxios, { AxiosResponse } from 'axios';

import { ICurrencyServiceMock } from './currency.mock.types';

export const mockCurrencyService = (): ICurrencyServiceMock => ({
  fetchCurrencies: jest.fn(),
  fetchCurrency: jest.fn(),
  createCurrency: jest.fn(),
  updateCurrency: jest.fn(),
  deleteCurrency: jest.fn()
});

export const mockCurrencyAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
